{
  "title": "Вход",
  "passkey": "Войти по passkey",
  "passkeyHint": "Face ID, Touch ID, Windows Hello или аппаратный ключ.",
  "or": "или по паролю",
  "email": "E-mail",
  "password": "Пароль",
  "submit": "Войти",
  "codeTitle": "Двухэтапная проверка",
  "codeLead": "Введите 6-значный код из приложения-аутентификатора.",
  "code": "Код",
  "useRecovery": "Ввести код восстановления",
  "useTotp": "Использовать приложение-аутентификатор",
  "recoveryCode": "Код восстановления",
  "verify": "Подтвердить",
  "passkeyCancelled": "Запрос passkey отменён."
}
